/**
 * Mainbeauty — client-side validation for every [data-pi-form].
 */

// Bỏ ký tự phân tách rồi khớp số VN: 10 số bắt đầu bằng 0, hoặc +84/84 theo sau 9 số.
const PHONE_RE = /^(0\d{9}|(\+?84)\d{9})$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function fieldLabel(input) {
	const ph = (input.dataset.piPh ?? input.getAttribute("placeholder") ?? "").trim();
	return ph || "thông tin này";
}

function isEmailField(input) {
	return input.type === "email" || input.name === "email";
}

// Trả { message, kind }: "empty" hiện trong placeholder, "format" hiện dòng dưới, rỗng là hợp lệ.
function validateField(input) {
	const raw = (input.value || "").trim();

	if (!raw) {
		if (!input.hasAttribute("required")) return { message: "", kind: "" };
		return input.tagName === "SELECT"
			? { message: `Vui lòng chọn ${fieldLabel(input)}.`, kind: "format" }
			: { message: `Vui lòng nhập ${fieldLabel(input)}.`, kind: "empty" };
	}
	if (input.name === "phone" && !PHONE_RE.test(raw.replace(/[\s.\-()]/g, ""))) {
		return {
			message: "Số điện thoại chưa đúng, vui lòng nhập lại (VD: 0901 234 567).",
			kind: "format",
		};
	}
	if (isEmailField(input) && !EMAIL_RE.test(raw)) {
		return { message: "Email chưa đúng định dạng (VD: ten@email.com).", kind: "format" };
	}
	return { message: "", kind: "" };
}

function inlineNode(input) {
	let node = input.nextElementSibling;
	if (node && node.hasAttribute("data-pi-field-error")) return node;
	node = document.createElement("p");
	node.className = "pi-form__field-error";
	node.setAttribute("data-pi-field-error", "");
	input.insertAdjacentElement("afterend", node);
	return node;
}

function hideInline(input) {
	const node = input.nextElementSibling;
	if (node && node.hasAttribute("data-pi-field-error")) node.hidden = true;
}

function showFieldError(input, result) {
	input.classList.add("is-invalid");
	input.setAttribute("aria-invalid", "true");

	if (result.kind === "empty") {
		// Nhớ placeholder gốc (chỉ lần đầu) rồi thay bằng thông báo lỗi.
		if (input.dataset.piPh === undefined) {
			input.dataset.piPh = input.getAttribute("placeholder") || "";
		}
		input.setAttribute("placeholder", result.message);
		hideInline(input);
	} else {
		const node = inlineNode(input);
		node.textContent = result.message;
		node.hidden = false;
	}
}

function clearFieldError(input) {
	input.classList.remove("is-invalid");
	input.removeAttribute("aria-invalid");
	hideInline(input);
	if (input.dataset.piPh !== undefined) {
		input.setAttribute("placeholder", input.dataset.piPh);
	}
}

function fields(form) {
	return Array.prototype.filter.call(
		form.querySelectorAll(
			".pi-form__body .inp, .pi-form__body input, .pi-form__body select, .pi-form__body textarea"
		),
		(el) => el.name
	);
}

function validateForm(form) {
	let firstInvalid = null;
	fields(form).forEach((input) => {
		const result = validateField(input);
		if (result.message) {
			showFieldError(input, result);
			if (!firstInvalid) firstInvalid = input;
		} else {
			clearFieldError(input);
		}
	});
	if (firstInvalid) firstInvalid.focus();
	return !firstInvalid;
}

function init() {
	document.querySelectorAll("[data-pi-form]").forEach((form) => {
		// Tắt bong bóng mặc định của trình duyệt để dùng thông báo tiếng Việt.
		form.noValidate = true;

		// Xóa lỗi ngay khi người dùng sửa lại field.
		fields(form).forEach((input) => {
			const revalidate = () => {
				if (!input.classList.contains("is-invalid")) return;
				const result = validateField(input);
				if (result.message) showFieldError(input, result);
				else clearFieldError(input);
			};
			input.addEventListener("input", revalidate);
			input.addEventListener("change", revalidate);
			input.addEventListener("blur", revalidate);
		});
	});

	// Capture phase: chạy trước handler submit của theme và plugin leads.
	document.addEventListener(
		"submit",
		(e) => {
			const form = e.target.closest && e.target.closest("[data-pi-form]");
			if (!form) return;
			if (!validateForm(form)) {
				e.preventDefault();
				e.stopImmediatePropagation();
			}
		},
		true
	);
}

document.addEventListener("DOMContentLoaded", init);
